/* WobbleBag hero slider: native scroll-snap track + dots + optional autoplay. */
if (!customElements.get('wb-hero-slider')) {
  customElements.define(
    'wb-hero-slider',
    class WbHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.wb-hero__track');
        this.slides = Array.from(this.querySelectorAll('.wb-hero-slide'));
        this.dots = Array.from(this.querySelectorAll('.wb-hero__dot'));
        this.current = 0;
        if (!this.track || this.slides.length < 2) return;

        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.to))));

        // Arrows wrap around, so the last slide's "next" returns to the first.
        const step = (delta) => {
          const count = this.slides.length;
          this.goTo((this.current + delta + count) % count);
        };
        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => step(-1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => step(1));

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.index));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        this.delay = Number(this.dataset.autoplay) || 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.delay && !this.reducedMotion) {
          this.pause = this.pause.bind(this);
          this.play = this.play.bind(this);
          this.addEventListener('mouseenter', this.pause);
          this.addEventListener('mouseleave', this.play);
          this.addEventListener('focusin', this.pause);
          this.addEventListener('focusout', this.play);
          this.track.addEventListener('touchstart', this.pause, { passive: true });
          this.track.addEventListener('touchend', this.play, { passive: true });
          this.play();
        }

        this.onBlockSelect = (event) => {
          const index = this.slides.findIndex((slide) => slide.contains(event.target));
          if (index < 0) return;
          this.editorLocked = true;
          this.pause();
          this.goTo(index, 'auto');
        };
        this.onBlockDeselect = () => {
          this.editorLocked = false;
          this.play();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        this.pause();
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      goTo(index, behavior) {
        const total = this.slides.length;
        const target = this.slides[((index % total) + total) % total];
        this.track.scrollTo({
          left: target.offsetLeft,
          behavior: behavior || (this.reducedMotion ? 'auto' : 'smooth'),
        });
      }

      setActive(index) {
        this.current = index;
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('inert', i !== index);
          slide.querySelectorAll('a').forEach((link) => link.removeAttribute('tabindex'));
        });
      }

      play() {
        if (!this.delay || this.reducedMotion || this.editorLocked) return;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (!document.hidden) this.goTo(this.current + 1);
        }, this.delay);
      }

      pause() {
        clearInterval(this.timer);
      }
    }
  );
}
